<template>
  <main class="terrain-access">
    <section class="terrain-access__card">
      <p v-if="loadingInfo">Cargando…</p>
      <template v-else-if="infoError">
        <h1>Acceder a campaña de terreno</h1>
        <p class="terrain-access__error" role="alert">{{ infoError }}</p>
      </template>
      <template v-else>
        <h1>{{ restricted ? 'Responder campaña de terreno' : 'Acceder a campaña de terreno' }}</h1>
        <p class="terrain-access__lead">
          <template v-if="restricted">Esta campaña requiere correo y key. Si tenés el enlace individual que te enviamos, es más rápido — este también funciona.</template>
          <template v-else>Ingresá el correo con el que vas a participar en esta campaña.</template>
        </p>
        <form @submit.prevent="continueToCampaign">
          <label class="terrain-access__field">Correo electrónico
            <input v-model.trim="email" type="email" autocomplete="email" required :disabled="loading">
          </label>
          <label v-if="restricted" class="terrain-access__field">Key de acceso
            <input v-model.trim="key" type="text" autocomplete="one-time-code" placeholder="XXXX-XXXX-XXXX" maxlength="14" required :disabled="loading">
          </label>
          <p v-if="errorMessage" class="terrain-access__error" role="alert">{{ errorMessage }}</p>
          <button type="submit" class="terrain-access__submit" :disabled="loading">{{ loading ? 'Ingresando…' : 'Continuar' }}</button>
        </form>
        <p v-if="!restricted" class="terrain-access__hint">Este acceso no verifica que el correo te pertenezca.</p>
      </template>
    </section>
  </main>
</template>

<script>
import { createTerrainApi } from "../../services/terrain/api.js";
export default {
  name: "TerrainPublicAccess",
  data: () => ({ loadingInfo: true, infoError: "", sharedAccessMode: "", email: "", key: "", loading: false, errorMessage: "" }),
  computed: {
    terrainApi() { return createTerrainApi(this.$http, this.$store.getters.backendurl); },
    restricted() { return this.sharedAccessMode === "restricted"; },
  },
  created() { this.loadInfo(); },
  methods: {
    async loadInfo() {
      this.loadingInfo = true;
      try {
        const response = await this.terrainApi.getPublicCampaignInfo(this.$route.params.publicAccessId);
        this.sharedAccessMode = response.data.sharedAccessMode;
      } catch (_) {
        this.infoError = "Este enlace no está disponible.";
      } finally {
        this.loadingInfo = false;
      }
    },
    async continueToCampaign() {
      this.loading = true; this.errorMessage = "";
      try {
        const response = this.restricted
          ? await this.terrainApi.createGeneralControlledSession(this.$route.params.publicAccessId, this.email, this.key.toUpperCase())
          : await this.terrainApi.createPublicSession(this.$route.params.publicAccessId, this.email);
        this.$router.replace({ name: response.data.prefill ? "terrain-prefill-inbox" : "terrain-campaign-form", params: { campaignId: response.data.campaignId } });
      } catch (error) {
        this.errorMessage = this.restricted
          ? "El correo o la key no son válidos, o la campaña no está disponible."
          : "El enlace o el correo no están disponibles para esta campaña.";
      }
      finally { this.loading = false; }
    },
  },
};
</script>

<style scoped lang="scss">
.terrain-access { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: var(--terrain-space-xl); background: var(--color-white); }

.terrain-access__card {
  width: 100%;
  max-width: 420px;

  h1 { color: var(--color-navy); font-size: var(--terrain-font-heading); margin: 0 0 var(--terrain-space-sm); }
}

.terrain-access__lead { color: var(--color-graphite); margin: 0 0 var(--terrain-space-lg); }

.terrain-access__field {
  display: grid;
  gap: var(--terrain-space-xs);
  color: var(--color-navy);
  font-weight: 600;
  font-size: var(--terrain-font-caption);
  margin-bottom: var(--terrain-space-md);

  input {
    font: inherit;
    font-weight: 400;
    color: var(--color-graphite);
    padding: var(--terrain-space-sm) var(--terrain-space-md);
    border: 1px solid var(--color-line);
    border-radius: var(--terrain-radius-md);
    transition: border-color var(--terrain-transition), box-shadow var(--terrain-transition);

    &:hover { border-color: var(--color-steel); }
    &:focus { outline: none; border-color: var(--color-steel); box-shadow: var(--terrain-shadow-sm); }
  }
}

.terrain-access__error {
  margin: 0 0 var(--terrain-space-md);
  padding: var(--terrain-space-sm) var(--terrain-space-md);
  background: var(--terrain-color-danger-light);
  color: var(--color-danger);
  border-radius: var(--terrain-radius-sm);
  font-size: var(--terrain-font-caption);
}

.terrain-access__submit {
  width: 100%;
  border: 0;
  border-radius: var(--terrain-radius-xl);
  background: var(--color-navy);
  color: var(--color-white);
  font: inherit;
  font-weight: 600;
  padding: var(--terrain-space-sm) var(--terrain-space-lg);
  cursor: pointer;
  transition: background-color var(--terrain-transition);

  &:hover:not(:disabled) { background: var(--color-steel); }
  &:disabled { background: var(--color-ghost); cursor: not-allowed; }
}

.terrain-access__hint { color: var(--color-ghost); font-size: var(--terrain-font-caption); margin: var(--terrain-space-lg) 0 0; }
</style>
